<template>
  <div class="newsDetail">
    <div class="contentCenter">
      <nav class="currentLocation">
        <ul class="display-flex">
          <li>
            <span>您的位置</span>
          </li>

          <li>
            <span>新闻资讯</span>
          </li>
        </ul>
      </nav>
      <div class="detail">
        <div
          class="detailBox"
          style="width: 900px; float: left;min-height:540px;margin-bottom:20px"
        >
          <div class="top">
            <h2>{{ newsDetail.title }}</h2>
            <div class="countAndTime">
              <span class="count">浏览量:{{ newsDetail.browsenum }}</span>
              <span class="time">发布时间:{{ newsDetail.time }}</span>
            </div>
          </div>
          <div class="html">
            <div v-html="newsDetail.detail"></div>
          </div>
          <div
            v-if="otherNews.length >= 1"
            class="bottom display-flex justify-content-space-between align-items-center"
          >
            <div class="lf" @click="handleTabArt('preve')">
              上一篇:{{ preveTitle }}
            </div>
            <div class="rg" @click="handleTabArt('next')">
              下一篇:{{ nextTitle }}
            </div>
          </div>
        </div>
        <div class="otherNews">
          <div
            class="publicTitle display-flex justify-content-space-between align-items-center"
          >
            <h5 class="h5">
              <img src="../assets/img/titleLine.png" alt /> 相关阅读
            </h5>
          </div>
          <div
            v-if="otherNews.length <= 0"
            style="min-height:250px"
            class="display-flex justify-content-space-around align-items-center"
          >
            暂无数据
          </div>
          <ul v-else class="otherList">
            <li v-for="item in otherNews.slice(0, 4)" :key="item.id">
              <h5 @click="handleChangeArt(item.id)">
                {{ item.title }}
              </h5>
              <div
                id="footer"
                class="display-flex justify-content-space-between align-items-center"
              >
                <div class="browseCount">
                  浏览量 <span>{{ item.browsenum }}</span>
                </div>
                <div class="time">{{ item.createtime.split(" ")[0] }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--<ContactWay />-->
  </div>
</template>

<script>
import ContactWay from "@/components/ContactWay.vue";
import { postData, showLoading, EventBus } from "../assets/api/api.js";
var newsId;
export default {
  name: "newsDetail",
  components: { ContactWay },
  data() {
    return {
      newsDetail: {},
      otherNews: [],
      artId: "",
      preveTitle: "",
      nextTitle: "",
    };
  },
  created() {
    this.artId = this.$route.query.id;
    this.loadDetdilData();
    this.loadNewsData();
    EventBus.$emit("changeNav", 3);
  },
  mounted() {
    EventBus.$on("handleChangeDetail", (id) => {
      this.artId = id;
      this.loadDetdilData();
      this.loadNewsData();
    });
  },
  computed: {},
  methods: {
    //点击相关阅读切换文章
    handleChangeArt(id) {
      this.artId = id;
      this.loadDetdilData();
      this.loadNewsData();
    },
    //点击翻篇
    handleTabArt(action) {
      var curArtIndex = newsId.indexOf(+this.artId);
      if (action == "preve") {
        //上一篇
        if (curArtIndex <= 0) {
          this.artId = newsId[newsId.length - 1];
        } else {
          this.artId = newsId[curArtIndex - 1];
        }
      } else {
        //下一篇
        if (curArtIndex >= newsId.length - 1) {
          this.artId = newsId[0];
        } else {
          this.artId = newsId[curArtIndex + 1];
        }
      }
      this.loadNewsData();
      this.loadDetdilData();
    },
    loadDetdilData() {
      showLoading();
      var params = {
        id: this.artId,
      };
      postData("article/detail", params).then((res) => {
        res.data.time = res.data.createtime.split(" ")[0];
        this.newsDetail = res.data;
      });
    },
    loadNewsData() {
      var params = {
        currentPage: 0,
        pageSize: 20,
      };
      postData("article/listPage", params).then((res) => {
        if (res.data) {
          if (res.data.entities) {
            newsId = res.data.entities.map((i) => i.id);
            var curArtIndex = newsId.indexOf(+this.artId);
            this.otherNews = res.data.entities.filter(
              (i) => i.id != this.artId
            );

            if (this.otherNews.length >= 1) {
              if (curArtIndex <= 0) {
                this.preveTitle = this.otherNews.find(
                  (i) => i.id == newsId[newsId.length - 1]
                ).title;
              } else {
                this.preveTitle = this.otherNews.find(
                  (i) => i.id == newsId[curArtIndex - 1]
                ).title;
              }
              if (curArtIndex >= newsId.length - 1) {
                this.nextTitle = this.otherNews.find(
                  (i) => i.id == newsId[0]
                ).title;
              } else {
                this.nextTitle = this.otherNews.find(
                  (i) => i.id == newsId[curArtIndex + 1]
                ).title;
              }
            }
          } else {
            this.otherNews = [];
          }
        } else {
          this.otherNews = [];
        }
      });
    },
  },
};
</script>
<style>
.newsDetail .contact {
  padding-top: 5px;
  background: #fff;
  position: fixed;
  right: 260px;
  top: 136px !important;
}
</style>
<style lang="scss" scoped>
.newsDetail {
  .detail {
    overflow: hidden;
    .bottom {
      padding-top: 50px;
      font-size: 14px;
      text-decoration: underline;
      color: rgba(34, 34, 34, 1);
      .lf:hover {
        color: #37bc5f;
      }
      .rg:hover {
        color: #37bc5f;
      }
      .lf {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
      .rg {
        text-align: right;
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
    }
    .top {
      margin-bottom: 28px;
      text-align: center;
      border-bottom: 1px solid #efeef1;
      padding-bottom: 16px;
      .countAndTime {
        color: #aaaaaa;
        margin-top: 15px;
        .time {
          margin-left: 42px;
        }
      }
      h2 {
        line-height: 30px;
        font-size: 30px;
        font-weight: bold;
        color: rgba(24, 29, 43, 1);
      }
    }
    .detailBox {
      padding: 40px 35px;
      background: #fff;
    }
    .browseCount {
      line-height: 15px;
      margin-top: 16px;
      color: rgba(170, 170, 170, 1);
      span {
        margin-left: 20px;
      }
    }
    .otherList {
      li {
        padding-left: 20px;
        padding-right: 20px;
        border-bottom: 1px solid #f3f3f5;
        padding-bottom: 10px;
        padding-top: 10px;
        h5:hover {
          color: #37bc5f;
          cursor: pointer;
        }
        h5 {
          width: 90%;
          font-size: 17px;
          line-height: 20px;
          color: rgba(34, 34, 34, 1);
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          overflow: hidden;
        }
        #footer {
          .time {
            margin-top: 16px;
            line-height: 15px;
            color: #aaaaaa;
          }
        }
      }
    }

    .otherNews {
      float: right;
      width: 280px;
      background: #fff;
    }
  }
}
</style>
